const NEWSLETTER_SELECTORS = {
  COUNTRY: '.newsletter-subscribe-country',
  EMAIL: '.newsletter-subscribe-email',
  FIELD_ERROR: '.newsletter-field-error',
  FORM: '.newsletter-subscribe-form',
  MESSAGE: '.newsletter__message',
  SUBSCRIBE_ERROR: '.newsletter-subscribe-error',
  SUBSCRIBE_SUCCESS: '.newsletter-subscribe-success',
};

const NEWSLETTER_CLASSNAMES = {
  HIDDEN: 'hidden',
};

function getKlaviyoPublicApiKey() {
  const form = document.querySelector(NEWSLETTER_SELECTORS.FORM);
  return form?.dataset.klaviyoKey;
}

function getNewsletterListId() {
  const form = document.querySelector(NEWSLETTER_SELECTORS.FORM);
  return form?.dataset.listId;
}

function showNewsletterError(fieldName) {
  document.querySelector(`.newsletter-${fieldName}-error`)?.classList.remove(NEWSLETTER_CLASSNAMES.HIDDEN);
}

function hideNewsletterErrors() {
  document.querySelectorAll(NEWSLETTER_SELECTORS.FIELD_ERROR).forEach((errorElement) => {
    errorElement.classList.add(NEWSLETTER_CLASSNAMES.HIDDEN);
  });
}

function hideNewsletterFeedback() {
  document.querySelectorAll(NEWSLETTER_SELECTORS.MESSAGE).forEach((errorElement) => {
    errorElement.classList.add(NEWSLETTER_CLASSNAMES.HIDDEN);
  });
}

function showNewsletterFeedback(succeeded) {
  hideNewsletterFeedback();
  if (succeeded) {
    const success = document.querySelector(NEWSLETTER_SELECTORS.SUBSCRIBE_SUCCESS);
    if (success) {
      success.classList.remove(NEWSLETTER_CLASSNAMES.HIDDEN);
    }
  } else {
    const error = document.querySelector(NEWSLETTER_SELECTORS.SUBSCRIBE_ERROR);
    if (error) {
      error.classList.remove(NEWSLETTER_CLASSNAMES.HIDDEN);
    }
  }
}

function subscribeToNewsletter(event) {
  event.preventDefault();
  const userEmail = document.querySelector(NEWSLETTER_SELECTORS.EMAIL)?.value;
  const userCountry = document.querySelector(NEWSLETTER_SELECTORS.COUNTRY)?.value;

  let isValid = true;
  hideNewsletterErrors();
  if (!userEmail) {
    isValid = false;
    showNewsletterError('email');
  }
  if (!userCountry) {
    isValid = false;
    showNewsletterError('country');
  }
  if (!isValid) {
    return;
  }
  const payload = {
    data: {
      type: 'subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              location: { country: userCountry },
              subscriptions: {
                email: { marketing: { consent: 'SUBSCRIBED' } },
              },
              email: userEmail,
              properties: {
                PAIS: userCountry,
              },
            },
          },
        },
      },
      relationships: { list: { data: { type: 'list', id: getNewsletterListId() } } },
    },
  };

  const options = {
    method: 'POST',
    headers: {
      accept: 'application/vnd.api+json',
      revision: '2025-01-15',
      'content-type': 'application/vnd.api+json',
    },
    body: JSON.stringify(payload),
  };

  fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${getKlaviyoPublicApiKey()}`, options)
    .then((result) => {
      if (result.status === 200 || result.status === 202) {
        showNewsletterFeedback(true);
      } else {
        showNewsletterFeedback(false);
      }
    })
    .catch((err) => {
      showNewsletterFeedback(false);
    });
}

function addSubscribeEvent() {
  const form = document.querySelector(NEWSLETTER_SELECTORS.FORM);
  if (form) {
    form.addEventListener('submit', subscribeToNewsletter);
  }
}

addSubscribeEvent();
